import { html, raw } from 'onefold';
import { CodeBlock } from '../../components/CodeBlock';
import { Callout } from '../../components/Callout';

export function CliPage(): Node {
  return html`
    <div>
      <h1>CLI (create-onefold)</h1>
      <p><code>create-onefold</code> scaffolds new onefold projects with pre-configured templates, build tools, and dev servers.</p>

      <h2>Quick Start</h2>
      ${CodeBlock(`npm create onefold@latest my-app
cd my-app
npm install
npm run dev`)}

      <h2>Templates</h2>
      <table>
        <tr><th>Template</th><th>Command</th><th>Description</th></tr>
        <tr><td>SPA</td><td><code>--template spa</code></td><td>Single-page app with router, esbuild, dev server.</td></tr>
        <tr><td>Fullstack</td><td><code>--template fullstack</code></td><td>SPA + Express server with SSR support.</td></tr>
        <tr><td>Microfrontend</td><td><code>--template microfrontend</code></td><td>Host + remote widgets with security config.</td></tr>
      </table>

      <h2>Usage</h2>
      ${CodeBlock(`# Interactive mode (prompts for template)
npm create onefold@latest my-app

# Specify template directly
npm create onefold@latest my-app -- --template spa
npm create onefold@latest my-app -- --template fullstack
npm create onefold@latest my-app -- --template microfrontend`)}

      <h2>Generated Structure (SPA)</h2>
      ${CodeBlock(`my-app/
├── src/
│   ├── main.ts          # Entry point
│   ├── pages/
│   │   ├── Home.ts
│   │   └── About.ts
│   └── components/
├── index.html           # HTML shell
├── style.css            # Global styles
├── build.mjs            # esbuild config
├── server.mjs           # Dev server
├── tsconfig.json
└── package.json`)}

      <h2>Generated Structure (Microfrontend)</h2>
      ${CodeBlock(`my-app/
├── host/
│   ├── src/main.ts      # Host shell with loadRemote
│   ├── build.mjs
│   └── package.json
├── remotes/
│   ├── billing/
│   │   ├── src/index.ts # Remote widget
│   │   └── build.mjs
│   └── analytics/
│       ├── src/index.ts
│       └── build.mjs
└── package.json`)}

      ${Callout('All templates use esbuild for fast builds. No webpack, no Vite — just a 5-line build.mjs script.')}

      <h2>Options</h2>
      ${raw(`<table>
        <tr><th>Flag</th><th>Description</th></tr>
        <tr><td><code>--template &lt;name&gt;</code></td><td>Template to use (spa, fullstack, microfrontend).</td></tr>
        <tr><td><code>--help</code></td><td>Show help.</td></tr>
        <tr><td><code>--version</code></td><td>Show CLI version.</td></tr>
      </table>`)}
    </div>
  `;
}
